"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _customProps = require("../../../../utils/customProps");

var _Storyblok = _interopRequireDefault(require("../../../../utils/Storyblok"));

var _MuiPaginationTableRow = _interopRequireDefault(require("../MuiPaginationTableRow/MuiPaginationTableRow"));

var MuiPaginationTableBody = function MuiPaginationTableBody(_ref) {
  var rootClass = _ref.rootClass,
      content = _ref.content,
      handleRowNums = _ref.handleRowNums,
      page = _ref.page,
      rowsPerPage = _ref.rowsPerPage;
  var components = {
    MuiPaginationTableRow: _MuiPaginationTableRow.default
  };
  (0, _react.useEffect)(function () {
    handleRowNums(content.length);
  }, []);

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass);

  return /*#__PURE__*/_react.default.createElement(_core.TableBody, {
    className: styles.root
  }, content.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(function (row, rowIndex) {
    return /*#__PURE__*/(0, _react.createElement)(components[row.component], Object.assign(row, {
      key: rowIndex
    }));
  }));
};

var _default = MuiPaginationTableBody;
exports.default = _default;
MuiPaginationTableBody.propTypes = {
  /**
   * stroyblok multiselect of css classes
   * Mui Override or extend the styles applied to the component.
   */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * function
   * Sets the number of rows in table.
   */
  // eslint-disable-next-line react/require-default-props
  handleRowNums: _propTypes.default.func,

  /**
   * default: 0
   * page number of table.
   */
  // eslint-disable-next-line react/require-default-props
  page: _propTypes.default.number,

  /**
   * default: 10
   * Sets the number of rows in table.
   */
  // eslint-disable-next-line react/require-default-props
  rowsPerPage: _propTypes.default.number,

  /**
   * Content passed to render
   * components:
    MuiPaginationTableRow,
   */
  content: function content(props, propName, componentName) {
    var components = ['MuiPaginationTableRow'];
    return (0, _customProps.validComponents)(props, propName, componentName, components);
  }
};
MuiPaginationTableBody.defaultProps = {
  rootClass: [],
  content: []
};